import { ProjectStatus } from '../../../../domain/projectStatus/projectStatus';
import TextAreaField from '../../../shared/components/forms/TextAreaField';
import TextField from '../../../shared/components/forms/TextField';
import ColorSelector from '../ColorSelector';

interface Props {
    projectStatus: ProjectStatus;
    onChange: (name: string, value: string | number | boolean | undefined) => void;
}

export default function ProjectStatusInformationSection({
    projectStatus,
    onChange: handleInputChange,
}: Props) {
    const handleColorChange = (
        name: string,
        value: string | number | boolean | undefined
    ) => {
        handleInputChange(name, value);
    };
    return (
        <>
            <h5 className='my-3'>Detalle del Estado</h5>
            <div className='col-6'>
                <TextField
                    label='Nombre del estado *'
                    name='name'
                    onChange={handleInputChange}
                    required={true}
                    value={projectStatus.name}
                    key='name'
                />
            </div>
            <div className='col-5'>
                <ColorSelector
                    onChange={handleColorChange}
                    value={projectStatus.color}
                    name='color'
                />
            </div>
            <div className='col-11'>
                <TextAreaField
                    name='description'
                    value={projectStatus.description}
                    label='Descripción del estado *'
                    required={false}
                    onChange={handleInputChange}
                    key='description'
                />
            </div>
        </>
    );
}
